import { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { PreviewCard, IsLoading } from "../components";
import { DocumentTitle, getGrades, getSubjects, paramsToObject } from "../utils";
import axios from "axios";
import { BASE_URL } from "../constants";

const Dashboard = ({ library }) => {
  const { type } = useParams();
  const [searchData, setSearchData] = useState({});
  const [loading, setLoading] = useState(false);
  const [cards, setCards] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [moreLoading, setMoreLoading] = useState(false);
  const [constants, setConstants] = useState([]);
  DocumentTitle(`IVY | Ineractive Videos`);

  const getConstants = async () => {
    const Grades = await getGrades();
    const Subjects = await getSubjects();

    setConstants({ Grades, Subjects });
  }

  useEffect(() => {
    constants.length == 0 && getConstants();
  }, [])

  const fetchCards = async (filters = {}) => {
    setSearchData(filters);
    const urlParams = new URLSearchParams(filters);
    const searchQuery = urlParams.toString();

    setLoading(true);
    setShowMore(false);
    const apiFile = type === "lesson" ? 'filterLessons.php' : 'filterVideos.php'

    try {
      axios.get(`${BASE_URL}/${type}/${apiFile}?${searchQuery}&library=${library}`).then((res) => {
        setLoading(false);

        setCards(res.data.data);
        if (res.data.data?.length > 11) setShowMore(true);
      })

    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchCards();
  }, [type, library])

  const handleSubmit = async (e) => {
    e.preventDefault();
    fetchCards(searchData);
  };

  const onShowMoreClick = async () => {
    const startIndex = cards?.length;
    const urlParams = new URLSearchParams(searchData);
    urlParams.set('startIndex', startIndex);
    const searchQuery = urlParams.toString();

    setMoreLoading(true);
    setShowMore(false);

    const apiFile = type === "lesson" ? 'filterLessons.php' : 'filterVideos.php'

    try {
      axios.get(`${BASE_URL}/${type}/${apiFile}?${searchQuery}&library=${library}`).then(res => {
        setMoreLoading(false);

        setCards([...cards, ...res.data.data]);
        if (res.data.data?.length > 11) setShowMore(true);
      })
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.id]: e.target.value,
    })
  }

  const handleClearFilters = () => {
    const urlParams = new URLSearchParams(searchData);
    urlParams.delete('searchTerm');
    urlParams.delete('grade_id');
    urlParams.delete('subject_id');
    setSearchData(paramsToObject(urlParams));
  }

  return (
    <section className="relative max-w-7xl page-container flex flex-col gap-4 w-full">
      <form className="max-w-4xl mx-auto w-full flex max-sm:flex-col gap-2" onSubmit={handleSubmit} id="filters">
        <div className="relative w-full">
          <input
            type="text"
            id="searchTerm"
            placeholder={`Search ${type} title..`}
            className="filter-bar"
            onChange={handleChange}
            value={searchData.searchTerm || ""}
          />

          <button className="absolute right-0 inset-y-0 rounded-lg p-2"><FaSearch /></button>
        </div>

        <select value={searchData.grade_id || ""} id="grade_id" className="filter-bar" onChange={handleChange}>
          <option value="" disabled>Select Grade</option>
          {constants.Grades?.map((grade, idx) => (
            <option
              key={idx}
              value={grade.id}
            >
              {grade.grade}
            </option>
          ))}
        </select>

        <select value={searchData.subject_id || ""} id="subject_id" className="filter-bar" onChange={handleChange}>
          <option value="" disabled>Select Subject</option>
          <option value="-2" >All</option>
          {constants.Subjects?.map((subject, idx) => (
            <option
              key={idx}
              value={subject.id}
            >
              {subject.title}
            </option>
          ))}
        </select>

        <button onClick={handleClearFilters} className="rounded-full py-2 px-4 bg-gray-500 text-gray-200 active:bg-gray-600">Clear</button>
        <button className="submit">Search</button>
      </form>

      <div className="flex flex-col gap-2">
        {
          loading ? <IsLoading />
            : (
              cards?.length === 0 ? <h1 className='text-lg text-center font-semibold text-lightAqua'>No Result Found!</h1>
                :
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                  {cards?.map((card, idx) => <PreviewCard key={idx} card={card} constants={constants} />)}
                </div>
            )
        }

        {/* show more */}
        {moreLoading && <IsLoading />}

        {showMore && (
          <div className='flex justify-center'>
            <button
              onClick={onShowMoreClick}
              className='hover-link'
            >
              Show more
            </button>
          </div>
        )}
      </div>
    </section>
  )
}

export default Dashboard